var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 55 39",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 55,
    height: 39,
    fill: "none",
    customFrame: "#000000",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Union",
    d: "M0 35.5C0 37.433 1.56701 39 3.5 39L51.5 39C53.433 39 55 37.433 55 35.5L55 3.5C55 1.567 53.433 0 51.5 0L3.5 3.734e-06C1.567 3.81199e-06 0 1.56701 0 3.5L0 35.5ZM52 3.5L52 8L3 8L3 3.5C3 3.22386 3.22386 3 3.5 3L51.5 3C51.7761 3 52 3.22386 52 3.5ZM52 11L3 11L3 35.5C3 35.7761 3.22386 36 3.5 36L24.0004 36L24.0004 34L20.5453 34C17.9765 34 15.5639 32.7664 14.0599 30.6839L8.75733 23.342C7.4639 21.5511 7.86719 19.0507 9.65809 17.7573C11.449 16.4639 13.9493 16.8671 15.2428 18.658L20.5453 26L38.2236 26C40.559 26 42.6822 27.3551 43.6656 29.4733L46.6959 36L51.5 36C51.7761 36 52 35.7761 52 35.5L52 11ZM32.0001 12C28.6863 12 26.0001 14.6863 26.0001 18C26.0001 21.3137 28.6863 24 32.0001 24C35.3138 24 38.0001 21.3137 38.0001 18C38.0001 14.6863 35.3138 12 32.0001 12ZM29.0001 18C29.0001 16.3431 30.3432 15 32.0001 15C33.6569 15 35.0001 16.3431 35.0001 18C35.0001 19.6569 33.6569 21 32.0001 21C30.3432 21 29.0001 19.6569 29.0001 18ZM27.0004 36L37.0004 36L37.0004 33.7835C37.0004 33.0797 37.4897 32.4705 38.1769 32.3188C38.8642 32.167 39.5645 32.5135 39.8609 33.1518L41.1832 36L43.3883 36L40.9446 30.7367C40.4529 29.6776 39.3913 29 38.2236 29L20.5453 29C19.582 29 18.6773 28.5374 18.1133 27.7565L12.8107 20.4145C12.4874 19.9668 11.8623 19.866 11.4146 20.1893C10.9668 20.5127 10.866 21.1378 11.1894 21.5855L16.4919 28.9275C17.4319 30.229 18.9398 31 20.5453 31L25.5004 31C26.3288 31 27.0004 31.6716 27.0004 32.5L27.0004 36Z",
    fill: "rgb(29,29,27)",
    fillOpacity: 0.400000006,
    fillRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg1);
export default __webpack_public_path__ + "static/media/1.54818c7c7df48a2f9d9045dd95a60eba.svg";
export { ForwardRef as ReactComponent };